module.exports = __webpack_public_path__ + "img/icon-error.ae576422.svg";